module.exports = __webpack_public_path__ + "img/weChat.65dbc6d1.png";